import ActivityLog from './ActivityLog';

interface GroupedLogs {
    [date: string]: {
        logId: string;
        time: string;
        message: React.ReactNode;
    }[];
}

interface FormattedLog {
    logId: string;
    createdAt: Date;
    activityLogFormatedMessage: React.ReactNode;
}

interface ActivityListingProps {
    activityLogs: FormattedLog[];
}

const groupLogsByDate = (logs: FormattedLog[]): GroupedLogs => {
    return logs.reduce((acc: GroupedLogs, log) => {
        const date = log.createdAt.toLocaleDateString(undefined, {
            month: 'long',
            day: 'numeric',
        });

        const time = log.createdAt.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });

        if (!acc[date]) {
            acc[date] = [];
        }

        acc[date].push({ logId: log.logId, time, message: log.activityLogFormatedMessage });

        return acc;
    }, {});
};

const ActivityListing = ({ activityLogs }: ActivityListingProps) => {
    const groupedLogs = groupLogsByDate(activityLogs);

    return (
        <div className="profile-activity-log__content">
            {Object.entries(groupedLogs).map(([date, logs]) => (
                <ActivityLog key={date} title={date} logs={logs} />
            ))}
        </div>
    );
};

export default ActivityListing;
